const getDisclaimer = (state, componentErrorId, clapiDisclaimerId, errorMsg) => {
    const disclaimerErr = state.errorHandler.get('componentErrors').get(componentErrorId);
    const disclaimerContext = state.clapi.get(clapiDisclaimerId) ?? {
        disclaimer: null,
        isFetching: true,
    }
    return {
        context: !!disclaimerErr ? {
            disclaimer: errorMsg.replace('{status}', disclaimerErr?.status),
            isFetching: false,
        } : disclaimerContext,
        hasError: !!disclaimerErr,
    };
};

export default getDisclaimer;
